import { SiteTrendModel } from "./SiteTrendModel";
export class SiteEnterococciTrendModel extends SiteTrendModel {   
    EntPer100Ml : number;

    constructor(measurementDt : Date,
        entPer100Ml : number)
    {
        super(measurementDt);           
        this.EntPer100Ml = entPer100Ml;
    }
}